import React, { useState } from 'react';
import AdminUserList from './AdminUserList';
import AdminWebhookEvents from './AdminWebhookEvents';
import AdminYouTube from './AdminYouTube';
import AdminMobile from './AdminMobile';
import AdminClubs from './AdminClubs';
import AdminSystem from './AdminSystem';
import AdminAICosts from './AdminAICosts';
import './AdminPanel.css';

type AdminTab = 'users' | 'clubs' | 'ai-costs' | 'webhooks' | 'youtube' | 'mobile' | 'system';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>('users');

  return (
    <div className="admin-panel">
      <div className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          Użytkownicy
        </button>
        <button
          className={`admin-tab ${activeTab === 'clubs' ? 'active' : ''}`}
          onClick={() => setActiveTab('clubs')}
        >
          Kluby
        </button>
        <button
          className={`admin-tab ${activeTab === 'ai-costs' ? 'active' : ''}`}
          onClick={() => setActiveTab('ai-costs')}
        >
          AI Costs
        </button>
        <button
          className={`admin-tab ${activeTab === 'webhooks' ? 'active' : ''}`}
          onClick={() => setActiveTab('webhooks')}
        >
          Webhooks
        </button>
        <button
          className={`admin-tab ${activeTab === 'youtube' ? 'active' : ''}`}
          onClick={() => setActiveTab('youtube')}
        >
          YouTube Generator
        </button>
        <button
          className={`admin-tab ${activeTab === 'mobile' ? 'active' : ''}`}
          onClick={() => setActiveTab('mobile')}
        >
          Mobile / Powiadomienia
        </button>
        <button
          className={`admin-tab ${activeTab === 'system' ? 'active' : ''}`}
          onClick={() => setActiveTab('system')}
        >
          System
        </button>
        <a
          href="https://github.com/formit04/alpsepic/issues"
          className="admin-tab"
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Dev Board
        </a>
      </div>

      <div className="admin-content">
        {activeTab === 'users' && <AdminUserList />}
        {activeTab === 'clubs' && <AdminClubs />}
        {activeTab === 'ai-costs' && <AdminAICosts />}
        {activeTab === 'webhooks' && <AdminWebhookEvents />}
        {activeTab === 'youtube' && <AdminYouTube />}
        {activeTab === 'mobile' && <AdminMobile />}
        {activeTab === 'system' && <AdminSystem />}
      </div>
    </div>
  );
};

export default AdminPanel;
